import { Component, OnDestroy, OnInit } from '@angular/core';
import { ComponentBaseComponent } from '../component-base/component-base.component';

@Component({
    selector: 'tt-kendo-base',
    templateUrl: './kendo-base.component.html',
    styleUrls: ['./kendo-base.component.css'],
})
export class KendoBaseComponent extends ComponentBaseComponent implements OnInit, OnDestroy {
    public _kendoComponentId = crypto.randomUUID();

    private setDisabledOnLinkElementWithId(id: string, disabled: boolean) {
        const element = document.getElementById(id);

        if (element && element.tagName === 'LINK') {
            (element as HTMLLinkElement).disabled = disabled;
        }
    }

    private setDisabledOnLegacyKendoStyles(disabled: boolean) {
        this.setDisabledOnLinkElementWithId('kendo-common', disabled);
        this.setDisabledOnLinkElementWithId('kendo-theme', disabled);
    }

    private setDisabledOnKendoMaterialStyles(disabled: boolean) {
        this.setDisabledOnLinkElementWithId('kendo-material', disabled);
    }

    ngOnInit(): void {
        KendoComponentRegistry.set(this._kendoComponentId, this);
        const root = document?.querySelector(':root');

        if (!!root) {
            root.classList.add('kendo-material-enabled');
            this.setDisabledOnLegacyKendoStyles(true);
            this.setDisabledOnKendoMaterialStyles(false);
        }
    }

    ngOnDestroy(): void {
        KendoComponentRegistry.delete(this._kendoComponentId);

        if (KendoComponentRegistry.size === 0) {
            const root = document?.querySelector(':root');

            if (!!root) {
                root.classList.remove('kendo-material-enabled');
                this.setDisabledOnLegacyKendoStyles(false);
                this.setDisabledOnKendoMaterialStyles(true);
            }
        }
    }
}

const KendoComponentRegistry = new Map<string, KendoBaseComponent>();
